import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, firstValueFrom } from 'rxjs';
import { DatosTareasDia } from 'src/app/adhoc/paginas/tareas-dia/utilidades/tareas-dia.models';
import { Parametros } from 'src/app/compartido/utilidades/compartido.models';
import { ErrorFrontend } from 'src/app/compartido/utilidades/error.utils';
import { Estadisticas } from 'src/app/reportes/paginas/utilidades/reportes.models';

@Injectable({ providedIn: 'root', deps: [HttpClient] })
export class AnaliticasService {
  constructor(private readonly http: HttpClient) {}

  /**
   * Obtiene las estadísticas de las tareas del día de una organización para la fecha proporcionada.
   * @param {string} fecha - Fecha para la que se desea obtener las tareas.
   * @param {number} organizacion - ID de la organización.
   * @returns {Promise<DatosTareasDia>} - Tareas del día de la organización (promise).
   * @throws {ErrorFrontend} - Si ocurre un error al obtener las tareas del día.
   * @author Juan Corral
   */
  public async obtenerTareasDelDia$(
    fecha: string,
    organizacion: number,
  ): Promise<DatosTareasDia> {
    const params: Parametros = { fecha, organizacion: organizacion.toString() };
    return firstValueFrom(
      this.http
        .get<DatosTareasDia>('analiticas/tareas_del_dia', { params })
        .pipe(
          catchError((error: HttpErrorResponse) => {
            throw new ErrorFrontend(error);
          }),
        ),
    );
  }

  /**
   * Obtiene las estadísticas según los filtros proporcionados.
   * @param {number} organizacion - ID de la organización.
   * @param {string} tipoFecha - El tipo de fecha a filtrar.
   * @param {string} fechaInicio - Fecha de inicio del rango.
   * @param {string} fechaFin - Fecha de fin del rango.
   * @param {number} sede [Opcional] - ID de la sede.
   * @param {string} prioridad [Opcional] - Prioridad de los domicilios.
   * @returns {Promise<Estadisticas>} - Tareas del día de la organización (promise).
   * @throws {ErrorFrontend} - Si ocurre un error al obtener las tareas del día.
   * @author Juan Corral
   */
  public async obtenerEstadisticas$(
    organizacion: number,
    tipoFecha: string,
    fechaInicio: string,
    fechaFin: string,
    sede?: number,
    prioridad?: string,
  ): Promise<Estadisticas> {
    const params: Parametros = {
      organizacion: organizacion.toString(),
      tipo_fecha: tipoFecha,
      fecha_inicio: fechaInicio,
      fecha_fin: fechaFin,
    };
    if (sede) params['sede'] = sede.toString();
    if (prioridad) params['prioridad'] = prioridad;
    return firstValueFrom(
      this.http.get<Estadisticas>('analiticas/reportes', { params }).pipe(
        catchError((error: HttpErrorResponse) => {
          throw new ErrorFrontend(error);
        }),
      ),
    );
  }
}
